import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, AutoComplete, message } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
import { CompanySelection } from 'kts-platform-frame/display/part';
import moment from 'moment';
import ModulesFormAction from './Modules.Form.Action';

const Option = Select.Option;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {
    // 交货日期
    public startValue: any;
    public endValue: any;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const { form } = this.props; // 获取你的props数
        const { getFieldDecorator } = form;
        const despatchAdviceForm = this.modulesState.despatchAdviceForm;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 17 },
            },
        };
        const dateFormat = this.modulesState.dateFormat;
        const messageInfos = this.modulesState.messageInfos;
        return (
            <Form className="form">
                <Row>
                    <Col span={12}>
                        <FormItem
                            {...formItemLayout}
                            label="收货方"
                        >
                            {getFieldDecorator('DeliveryCustomerParty', {
                                initialValue: despatchAdviceForm.DeliveryCustomerParty.Name,
                                rules: [{
                                    required: true,
                                    message: '请选择收货方',
                                }],
                            })(
                                <Input
                                    readOnly={true}
                                    placeholder=""
                                    onFocus={this.getonFocus}
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'DeliveryCustomerParty',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('DeliveryCustomerParty'))}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="收货联系人"
                        >
                            {getFieldDecorator('DeliveryCustomerContact', {
                                initialValue: despatchAdviceForm.DeliveryCustomerContact.Name,
                                rules: [{
                                    required: false,
                                    message: '',
                                    ...ModulesAction.getExtraRules('DeliveryCustomerContact', false)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'DeliveryCustomerContact',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('DeliveryCustomerContact'))}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="发货方"
                        >
                            {getFieldDecorator('DespatchSupplierParty', {
                                initialValue: despatchAdviceForm.DespatchSupplierParty.ID,
                                rules: [{
                                    required: true,
                                    message: '',
                                }],
                            })(
                                <span>{despatchAdviceForm.DespatchSupplierParty.Name}</span>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="发货联系人"
                        >
                            {getFieldDecorator('DespatchSupplierContact', {
                                initialValue: despatchAdviceForm.DespatchSupplierContact.ID,
                                rules: [],
                            })(
                                <span>{despatchAdviceForm.DespatchSupplierContact.Name}</span>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem
                            {...formItemLayout}
                            label="发货单编号"
                        >
                            {getFieldDecorator('ID', {
                                initialValue: despatchAdviceForm.ID,
                                rules: [{
                                    required: true,
                                    // pattern: /^.{0,50}$/,
                                    // message: '必填，支持不超过50个字符',
                                    message: '必填',
                                    ...ModulesAction.getExtraRules('ID', false)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'ID',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('ID'))}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="填报时间"
                        >
                            {getFieldDecorator('IssueDate', {
                                initialValue: ModulesAction.timeStampToFormat(despatchAdviceForm.IssueDate),
                                rules: [{
                                    required: true,
                                    message: '请选择时间',
                                }],
                            })(
                                <DatePicker
                                    showTime={{ format: this.modulesState.timeFormat }}
                                    placeholder=""
                                    style={{ width: '100%' }}
                                    format={dateFormat}
                                    disabledDate={ModulesAction.disabledDate}
                                    onChange={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'IssueDate',
                                        fieldType: 'DocField',
                                        line: null,
                                        value: moment(e).valueOf(),
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('IssueDate'))}
                        </FormItem>
                        <FormItem label="收货信息" {...formItemLayout}>
                            <Row gutter={10}>
                                <Col span={8} >
                                    <FormItem>
                                        {getFieldDecorator('Country', {
                                            initialValue: this.modulesState.despatchAdviceForm.DeliveryAddress.Country ? this.modulesState.despatchAdviceForm.DeliveryAddress.Country : undefined
                                        })(
                                            <Select
                                                placeholder="国家"
                                                onSelect={this.changeCountry}
                                                onChange={e => ModulesFormAction.validateFormValue({
                                                    fieldName: 'Country',
                                                    fieldType: 'DocField',
                                                    line: null,
                                                    value: e,
                                                })}
                                            >
                                                {this.countryList()}
                                            </Select>
                                        )}
                                        {ModulesFormAction.setMessageInfos(messageInfos.get('Country'))}
                                    </FormItem>
                                </Col>
                                <Col span={8} >
                                    <FormItem>
                                        {getFieldDecorator('CountrySubentity', {
                                            initialValue: this.modulesState.despatchAdviceForm.DeliveryAddress.CountrySubentity ? this.modulesState.despatchAdviceForm.DeliveryAddress.CountrySubentity : undefined
                                        })(
                                            <Select
                                                placeholder="省/直辖市"
                                                optionFilterProp="children"
                                                className="city2"
                                                onSelect={this.changeState}
                                                onChange={e => ModulesFormAction.validateFormValue({
                                                    fieldName: 'CountrySubentity',
                                                    fieldType: 'DocField',
                                                    line: null,
                                                    value: e,
                                                })}
                                            >
                                                {this.provinceList()}
                                            </Select>
                                        )}
                                        {ModulesFormAction.setMessageInfos(messageInfos.get('CountrySubentity'))}
                                    </FormItem>
                                </Col>
                                <Col span={8} >
                                    <FormItem>
                                        {getFieldDecorator('CityName', {
                                            initialValue: this.modulesState.despatchAdviceForm.DeliveryAddress.CityName ? this.modulesState.despatchAdviceForm.DeliveryAddress.CityName : undefined
                                        })(
                                            <Select
                                                placeholder="城市/区县"
                                                optionFilterProp="children"
                                                className="city1"
                                                onChange={e => ModulesFormAction.validateFormValue({
                                                    fieldName: 'CityName',
                                                    fieldType: 'DocField',
                                                    line: null,
                                                    value: e,
                                                })}
                                            >
                                                {this.cityList()}
                                            </Select>
                                        )}
                                        {ModulesFormAction.setMessageInfos(messageInfos.get('CityName'))}
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                        <Col>
                            <FormItem
                                wrapperCol={{ span: 17, offset: 5 }}
                            >
                                {getFieldDecorator('AddressLine', {
                                    initialValue: this.modulesState.despatchAdviceForm.DeliveryAddress.AddressLine,
                                    rules: [
                                        {
                                            required: false,
                                            //规则注释 pattern: /^.{0,200}$/,
                                            //规则注释 message: '支持不超过200个字符',
                                        }
                                    ],
                                })(
                                    <Input
                                        placeholder="街道门牌"
                                        onBlur={e => ModulesFormAction.validateFormValue({
                                            fieldName: 'AddressLine',
                                            fieldType: 'DocField',
                                            line: null,
                                            value: e.target.value,
                                        })}
                                    />
                                )}
                                {ModulesFormAction.setMessageInfos(messageInfos.get('AddressLine'))}
                            </FormItem>
                        </Col>
                        <Row>
                            <Col span={8} offset={5}>
                                <FormItem
                                    wrapperCol={{ span: 24 }}
                                >
                                    {getFieldDecorator('DeliveryContactName', {
                                        initialValue: this.modulesState.despatchAdviceForm.DeliveryContact.Name,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,20}$/,
                                            //规则注释 message: '支持不超过20个字符',
                                        }],
                                    })(
                                        <Input
                                            placeholder="收货联系人"
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'DeliveryContactName',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('DeliveryContactName'))}
                                </FormItem>
                            </Col>
                            <Col span={9}>
                                <FormItem
                                    wrapperCol={{ span: 23, offset: 1 }}
                                >
                                    {getFieldDecorator('DeliveryContactPhone', {
                                        initialValue: this.modulesState.despatchAdviceForm.DeliveryContact.Phone,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,20}$/,
                                            //规则注释 message: '支持不超过20个字符',
                                        }],
                                    })(
                                        <Input
                                            placeholder="联系电话"
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'DeliveryContactPhone',
                                                fieldType: 'DocField',
                                                line: null,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('DeliveryContactPhone'))}
                                </FormItem>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Form>
        );
    }
    private getonFocus = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <CompanySelection
                showSearch={true}
                isCheck={false}
                onSubmitCompany={this.onSubmitCompany}
                request={ModulesAction.pageListUsersList}
            />,
            title: '企业选择'
        });
    }
    /** 选择公司后的保存 */
    private onSubmitCompany = (data: any) => {
        if (data.length) {
            this.props.form.setFieldsValue({ DeliveryCustomerParty: data[0].connectionName });
            ModulesAction.saveSellerSupplie(data);
            // 关闭右侧弹窗
            MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.remove, {
                title: '企业选择',
                isHide: true,
            });
        } else {
            message.warning('请企业选择');
        }

    }
    /** 开始时间限制 */
    private disabledStartDate = (startValue) => {
        const endValue = this.endValue;
        if (!startValue || !endValue) {
            return false;
        }
        return Math.ceil(startValue.valueOf() / 86400000) > Math.ceil(endValue.valueOf() / 86400000);
    }
    /**
     * 结束时间限制
     */
    private disabledEndDate = (endValue) => {
        const startValue = this.startValue;
        if (!endValue || !startValue) {
            return false;
        }
        return Math.ceil(endValue.valueOf() / 86400000) < Math.ceil(startValue.valueOf() / 86400000);
    }
    /** 起始时间改变 */
    private onStartChange = (value) => {
        this.startValue = value;
    }
    /** 结束时间改变 */
    private onEndChange = (value) => {
        this.endValue = value;
    }
    /** 拼接国家列表 */
    private countryList = () => {
        let list = [];
        if (this.modulesState.countryList) {
            this.modulesState.countryList.map((item, index) => {
                list.push(<Option value={item.code} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接省列表 */
    private provinceList = () => {
        let list = [];
        if (this.modulesState.provinceList) {
            this.modulesState.provinceList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接市列表 */
    private cityList = () => {
        let list = [];
        if (this.modulesState.cityList) {
            this.modulesState.cityList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 国家下拉框改变 */
    private changeCountry = (va) => {
        this.props.form.setFieldsValue({ CountrySubentity: undefined, CityName: undefined });
        ModulesAction.getProvince(va);
    }
    /** 省下拉框改变 */
    private changeState = (va, option) => {
        this.props.form.setFieldsValue({ CityName: undefined });
        ModulesAction.getCity(va);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.DespatchAdviceFormBasicInfo.tsx